export const NAME_MODAL_ID = 'account-settings-name-modal';

export const PHONE_MODAL_ID = 'account-settings-phone-modal';

export const VERIFY_EMAIL_MODAL_ID = 'account-settings-verofy-email-modal';
